module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('loading'), _vm._v(" "), _c('snackbar', {
    ref: "snackbar",
    attrs: {
      "ef-position": "bottom center",
      "ef-duration": "5000"
    },
    on: {
      "close": _vm.onCloseSnackbar
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.application.snackbar.message)
    }
  }), _vm._v(" "), (_vm.application.snackbar.action.text && _vm.application.snackbar.action.handler) ? _c('button', {
    on: {
      "click": _vm.application.snackbar.action.handler
    }
  }, [_vm._v(_vm._s(_vm.application.snackbar.action.text))]) : _vm._e()]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-711da5d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 703
// module chunks = 42